import { useHealthblocksSWR, useSubjectId } from '@healthblocks-io/core'

import type { AllergyHealthProfile } from '../types/HealthProfile.types'

export function useAllergyHealthParameter() {
  const subjectId = useSubjectId()
  const queryParameters = new URLSearchParams()

  if (subjectId) {
    queryParameters.append('subjectId', String(subjectId))
  }

  const queryString = queryParameters.toString()

  return useHealthblocksSWR<AllergyHealthProfile>(
    `/views/patient/health-profile/allergies${queryString ? `?${queryString}` : ''}`,
  )
}
